import React from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import ViewAtributeForm from '../../../component/attributesComps/ViewAtributeForm';

const ViewVariants = () => {

  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Variants"  pagename="View Variants" buttonText="Save"/>
      <ViewAtributeForm />
    </div>
  );
};

export default ViewVariants;
